module.exports = __webpack_public_path__ + "static/img/pro-2.af4648c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-2.png
// module id = sxCS
// module chunks = 1